import { LinkButton } from '@cian/ui-kit/button';
import { Responsive } from '@cian/ui-kit/responsive';
import * as React from 'react';

import * as styles from './UserRelated.css';
import { LoginButton } from '../LoginButton';

interface IUserRelatedProps {
  gptButton: JSX.Element | null;
  userMenu: JSX.Element | null;
  utilities: JSX.Element;
  placeOfferLink: string | null;
  hasBlockedSanction: boolean;
  shouldShowNewPlacementText: boolean;
  experimentGroup: string | null;
  addOfferButton: JSX.Element;
  onPlaceOfferClick(): void;
  onAuthenticateClick(): void;
}

export const UserRelated: React.FC<IUserRelatedProps> = ({
  gptButton,
  userMenu,
  utilities,
  placeOfferLink,
  hasBlockedSanction,
  shouldShowNewPlacementText,
  onPlaceOfferClick,
  onAuthenticateClick,
  experimentGroup,
  addOfferButton,
}) => {
  return (
    <div className={styles['container']}>
      <Responsive desktop>{gptButton && <div className={styles['gpt-button']}>{gptButton}</div>}</Responsive>
      {
        /* При победе группы B или C, объединить кнопку "Разместить" для десктопа, планшета и мобвеба в компоненте AddOfferButton */
        ['B', 'C'].includes(experimentGroup || '') ? (
          <>
            <Responsive phone>{addOfferButton}</Responsive>
            <Responsive desktop tablet>
              <div className={styles['utilities']}>{utilities}</div>
            </Responsive>
          </>
        ) : (
          <div className={styles['utilities']}>{utilities}</div>
        )
      }
      <Responsive tablet desktop>
        {placeOfferLink && !hasBlockedSanction && (
          <div className={styles['place']}>
            <LinkButton
              href={placeOfferLink}
              size="XS"
              onClick={onPlaceOfferClick}
              data-testid="header-add-offer-buttons"
            >
              + {shouldShowNewPlacementText ? 'Разместить за 0 ₽' : 'Разместить объявление'}
            </LinkButton>
          </div>
        )}
        {userMenu || <LoginButton onAuthenticateClick={onAuthenticateClick} />}
      </Responsive>
    </div>
  );
};
